import Col from 'blocks/Col';
import Row, { RowItem } from 'blocks/Row';
import LanguageSwitcher from 'components/LanguageSwitcher';
import * as S from './auth.styles';
import { AuthLayoutProps } from './authLayout.interface';

const Auth = ({ topTitle, title, children, sideFooter }: AuthLayoutProps) => {
  return (
    <S.Wrapper>
      <S.Login as={Row}>
        <S.LoginLeftBox
          as={RowItem}
          gap={false}
          flex="0.9"
          style={{
            backgroundImage: `url(/passenger/images/static/signup-background.jpg)`,
          }}
        >
          <S.linerGradiant>
            <S.LoginImageBox as={Col} align="center" justify="end">
              <S.LanguageSwitcher>
                <LanguageSwitcher color={'white'} />
              </S.LanguageSwitcher>
            </S.LoginImageBox>
          </S.linerGradiant>
        </S.LoginLeftBox>
        {children}
      </S.Login>
    </S.Wrapper>
  );
};

export default Auth;
